import React, { Component } from 'react';
import { Row, Col, Form, InputGroup, Label, Button } from "reactstrap";
import { inject, observer } from "mobx-react";
import CalendarioPicker from '../../../comum/components/Calendario';
import InputFiltro from '../../../comum/components/InputFiltro';
import FormInputNumber from '../../../comum/components/FormInputNumber';
import SelectFiltro from "../../../comum/components/SelectFiltro";
import { Link } from "react-router-dom";
import { IconeSoma, FecharFiltro } from '../../../comum/components/Icones';
import Card from '../../../comum/components/Card';
import lscache from "lscache";
import SelectAsync from '../../../comum/components/SelectAsync';
import FormOnlyPositiveNumberSimples from "../../../comum/components/FormNumberSimples";

@inject("store")
@observer
export default class FiltrosNotaFiscalFaturamento extends Component {
  constructor(props) {
    super(props);
    {/* TODO: inserir proptypes */ }
    this.controller = this.props.controller;
    this.parametrosStore = this.props.store.parametrosStore;
    this.maisFiltros = lscache.get('notafiscalfaturamento-maisFiltros');
    this.state = {
      maisFiltros: this.maisFiltros ? this.maisFiltros : false,
      filtrado: false
    };
  }

  componentDidMount() {
    this.controller.inicializarFiltros();

    const pesquisa = lscache.get('acompProcesso-pesquisa-doc');
    if (pesquisa) {
      lscache.set('acompProcesso-pesquisa-voltar', 5);
      const documentoBL = lscache.get('acompProcesso-doc');
      this.setMaisFiltros(true);
      this.setState({ maisFiltros: true });
      this.controller.setFiltroSelecionado("bl", documentoBL ? documentoBL : null);
      this.filtrar();
    };
  }

  filtrar() {
    this.setState(state => ({ filtrado: true }));
    this.controller.carregarDadosConsulta()
  }

  filtros = () => {
    if (!this.state.maisFiltros) {
      this.controller.filtroCompleto = false;
      return this.filtrosBasicos();
    } else {
      this.controller.filtroCompleto = true;
      return this.filtrosCompletos();
    }
  };

  filtrosCompletos = () => {
    //this.controller.filtraPeriodo(true);
    let xl = 3; let lg = 6; let md = 4; let sm = 6; let xs = 12;
    return <React.Fragment>
      <Row className="align-items-end">
        <FormOnlyPositiveNumberSimples  titulo="Número Nota"
                                        className="mb-1"
                                        marginBottom="mb-1"
                                        xl={xl} md={4} sm={6} xs={12}
                                        dado={this.props.notaTecon}
                                        onEnter={() => this.filtrar()}
                                        onChange={event =>
                                          this.controller.setFiltroSelecionado("numero", event.target.value)
                                        }
                                        onBlur={event =>
                                          this.controller.setFiltroSelecionado("numero", event.target.value)
                                        }
        />
        {!process.env.rig &&
          <InputFiltro
            titulo="Número RPS"
            type="number"
            className="mb-2"
            xl={xl} md={4} sm={6} xs={12}
            onEnter={() => this.filtrar()}
            onChange={event =>
              this.controller.setFiltroSelecionado("rps", event.target.value)
            }
          />
        }
        <Col className="mb-2"
          xl={xl} md={4} sm={6} xs={12}>
          <div className="w-100">
            <Col xs={12} className="col-label px-0">
              <Label>Período </Label>
            </Col>
            <Col xs={12} className="px-0">
              <InputGroup className={'ativo'}>
                <CalendarioPicker visivel={this.controller.seletorPeriodo}
                  onChangeInicio={(valor) => this.controller.setDataInicio(valor)}
                  onChangeFim={(valor) => this.controller.setDataFim(valor)}
                  dateFormat={"YYYY-MM-DD"}
                  close={true}
                />
              </InputGroup>
            </Col>
          </div>
        </Col>

        {!process.env.rig &&
          <InputFiltro
            titulo="BL"
            className="mb-2"
            xl={xl} md={4} sm={6} xs={12}
            value={!this.props.notaTecon ? (lscache.get('acompProcesso-pesquisa-doc') ? lscache.get('acompProcesso-doc') : "") : ""}
            onEnter={() => this.filtrar()}
            onChange={event =>
              this.controller.setFiltroSelecionado("bl", event.target.value)
            }
          />
        }
        <InputFiltro
          titulo="Booking"
          className="mb-2"
          xl={xl} md={4} sm={6} xs={12}
          onEnter={() => this.filtrar()}
          onChange={event =>
            this.controller.setFiltroSelecionado("booking", event.target.value)
          }
        />
        <InputFiltro
          titulo="Due"
          className="mb-2"
          xl={xl} md={4} sm={6} xs={12}
          onEnter={() => this.filtrar()}
          onChange={event =>
            this.controller.setFiltroSelecionado("due", event.target.value)
          }
        />
        {!process.env.rig &&
          <InputFiltro
            titulo="Container"
            className="mb-2"
            xl={xl} md={4} sm={6} xs={12}
            onEnter={() => this.filtrar()}
            onChange={event =>
              this.controller.setFiltroSelecionado("container", event.target.value)
            }
          />
        }
        <InputFiltro
          titulo="DI"
          className="mb-2"
          xl={xl} md={4} sm={6} xs={12}
          onEnter={() => this.filtrar()}
          onChange={event =>
            this.controller.setFiltroSelecionado("di", event.target.value)
          }
        />

        <SelectAsync
          xl={4} lg={4} md={6} sm={12} xs={12}
          title="Navio"
          onSelectItem={this.controller.setNavio}
          loadOptionsCallback={this.controller.naviosOptions}
          placeholder={"Digite aqui"} />

        <SelectAsync
          xl={5} lg={5} md={6} sm={12} xs={12}
          title="Cliente"
          onSelectItem={this.controller.setCliente}
          loadOptionsCallback={this.controller.clientesOptions}
          placeholder={"Digite aqui"} />

        <Col sm={sm} xs={xs} className="mb-2 align-bottom">
          <Button className="btn-filtros ativo" onClick={() => this.mudaFiltros()} outline>
            <FecharFiltro color="#93A0AD" className="mr-2" width="15" height="15" />
            Menos filtros
                        </Button>
          <Button className="btn-com-bordas-primary btn-filtrar" disabled={this.controller.loading} onClick={() => this.filtrar()} >Filtrar</Button>
        </Col>
      </Row>
    </React.Fragment>
  };

  filtrosBasicos = () => {
    //this.controller.filtraPeriodo(false);
    let xl = 3; let lg = 6; let md = 4; let sm = 6; let xs = 12;
    return <React.Fragment>
      <Row className="align-items-end">
      <FormOnlyPositiveNumberSimples  titulo="Número Nota"
                                      xl={xl} md={4} sm={6} xs={12}
                                      dado={this.props.notaTecon}
                                      onEnter={() => this.filtrar()}
                                      onChange={event =>
                                        this.controller.setFiltroSelecionado("numero", event.target.value)
                                      }
                                      onBlur={event =>
                                        this.controller.setFiltroSelecionado("numero", event.target.value)
                                      }
        />
        <Col sm={sm} xs={xs} className="mb-4 align-bottom">
          <Button className="btn-filtros" onClick={() => this.mudaFiltros()} outline>
            <FecharFiltro color="#93A0AD" className="mr-2" width="15" height="15" />
            Mais filtros
                          </Button>
          <Button className="btn-com-bordas-primary btn-filtrar" disabled={this.controller.loading} onClick={() => this.filtrar()} >Filtrar</Button>
        </Col>
      </Row>
    </React.Fragment>
  };

  mudaFiltros = () => {
    this.setMaisFiltros(!this.state.maisFiltros);
    this.setState({ maisFiltros: !this.state.maisFiltros });
  };

  setMaisFiltros(bool) {
    lscache.set('notafiscalfaturamento-maisFiltros', bool, 5);
  }

  render() {

    {/* TODO : melhorar no mobile */ }
    return (
      <Card className="mb-0">
        <div className="filtros agendamento m-0 p-0">
          {this.filtros()}
        </div>
      </Card>
    )
  }
}


// WEBPACK FOOTER //
// ./src/modules/faturamento/notafiscal/components/FiltrosNotaFiscalFaturamento.js